__webpack_require__.p = "https://admin.core-artifacts.com/static/";